import { importWithRetry } from "utils/lazy-with-retry.util";

import type { AfterVisitSummaryPdfParams } from "./after-visit-summary-pdf-document.component";

/**
 * Render the After Visit Summary letter to a PDF blob.
 *
 * Both the renderer and the document view are imported dynamically, and that pairing is the whole
 * point of this module: `PdfDocument` imports `@react-pdf/renderer` at its top level, so importing
 * the document component eagerly would pull the PDF engine into whatever chunk reaches the AVS
 * dialog — which the chart note and the appointment page both do. Same arrangement as
 * `createFacesheetPdf` and `create-chart-note-pdf.util`.
 */
export async function createAfterVisitSummaryPdf(
  params: AfterVisitSummaryPdfParams
): Promise<Blob> {
  const [{ pdf }, { AfterVisitSummaryPdfDocument }] = await Promise.all([
    importWithRetry(
      () => import("@react-pdf/renderer"),
      "react-pdf-renderer"
    ).then((module) => ({ pdf: module.pdf })),
    importWithRetry(
      () => import("./after-visit-summary-pdf-document.component"),
      "after-visit-summary-pdf-document"
    )
  ]);

  return pdf(<AfterVisitSummaryPdfDocument {...params} />).toBlob();
}
